module.exports = __webpack_public_path__ + "img/anison_pianist_takechan_sp.8d16597b.png";